<template>
    <div>
        <el-checkbox-group v-model="tax">
            <div v-if="hasInvoice">
                <h3 class="mt-0">
                    {{ $l10n.__("Appliquer la TVA sur les factures d'acompte") }}
                </h3>
                <div class="form-group">
                    <el-checkbox label="taxOnDeposit">{{
                        $l10n.__("Appliquer la TVA sur les factures d'acompte")
                    }}</el-checkbox>
                </div>
            </div>

            <h3 :class="{ 'mt-0': !hasInvoice }">
                {{ $l10n.__('Assiette de TVA') }}
            </h3>
            <p>
                {{
                    $l10n.__(
                        "L'assiette de TVA est la base sur laquelle le montant de la TVA sera calculé",
                    )
                }}
            </p>
            <div class="form-group">
                <el-checkbox label="vatBase">{{
                    $l10n.__("Afficher l'assiette de TVA")
                }}</el-checkbox>
            </div>
            <div class="alert alert-warning">
                <p>
                    {{
                        $l10n.__(
                            "L'assiette de TVA n‘est pas disponible sur les documents utilisant la double taxe",
                        )
                    }}
                </p>
            </div>

            <h3>
                {{ $l10n.__('Double taxe') }}
            </h3>
            <p>
                {{ $l10n.__('Certains pays ou territoires utilisent deux taxes différentes.') }}
                {{
                    $l10n.__(
                        'Activez cette préférence si vous souhaitez que tous vos documents comportent deux colonnes de taxe.',
                    )
                }}
                {{ $l10n.__('Cette préférence peut aussi être activée document par document.') }}
            </p>
            <div class="form-group">
                <el-checkbox label="doubleVat">{{
                    $l10n.__('Utiliser la double taxe dans les documents')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultTax: {
            type: Array,
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
        hasInvoice: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        return {
            tax: this.defaultTax,
        };
    },
    methods: {
        save: function () {
            let options = {
                tax: this.tax,
            };

            this.$ajax.put(
                `/rest/documents/tax-preferences/${this.docPrefsId}`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    let errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
